import { render } from "./QueStem3.vue?vue&type=template&id=d5e56f4a&scoped=true"
import script from "./QueStem3.vue?vue&type=script&lang=js"
export * from "./QueStem3.vue?vue&type=script&lang=js"

import "./QueStem3.vue?vue&type=style&index=0&id=d5e56f4a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5e56f4a"]])

export default __exports__